export enum AuthRoutes {
  BasePrefix = "auth",
  Login = "login",
  RefreshToken = "token/refresh"
}
